export const EstadoCargaTablaParametros = {
    noSolicitada: "noSolicitada",
    cargada: "cargada",
    errorCarga: "errorCarga"
}

export const TipoCampo = {
    smallInteger: "small-integer",
    integer: "integer",
    single: "single",
    double: "double",
    long: "long",
    string: "string",
    date: "date",
    oid: "oid",
    geometry: "geometry",
    blob: "blob",
    raster: "raster",
    guid: "guid",
    globalId: "global-id",
    xml: "xml"
}

export const EstadosWidgetCerca = {
    createdSinQuitarEfecto: "createdSinQuitarEfecto",
    created: "created",
    drawing: "drawing",
    drawRunning: "drawRunning",
    drawn: "drawn",
    running: "running",
    executed: "executed"
}

export const CodigosListaListaResumenNoCargada = {
    max: "max", //Aplica solamente para TiposListaResumen.layerList
    errorAlCargar: "errorAlCargar"
}

export const CodigosControllers = {
    widgetLayerList: "widgetLayerList",
    widgetCerca: "widgetCerca",
}

export const TiposListaResumen = {
    layerList: "listasResumen",
    cerca: "listaResumenCerca",
}

export const AtributosGraphicsMapa = {
    tipo: "tipo",
    ofSublayer: "ofSublayer"
}